import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/Accordion";
import { useTranslation } from "react-i18next";

const OurValues = () => {
  const { t } = useTranslation();
  return (
    <section className="py-20 ">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-neutral-green-500 text-4xl md:text-6xl font-bold mb-12 text-center">
          {t("about.ourValues")}
        </h2>
        <p className="text-lg text-neutral-green-700 mb-12 text-center max-w-3xl mx-auto">
          {t("about.valuesDesc")}
        </p>
        <Accordion
          type="single"
          collapsible
          className="w-full max-w-3xl mx-auto"
        >
          <AccordionItem value={t("about.value1Title")}>
            <AccordionContent>
              {t("about.value1Content")}
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value={t("about.value2Title")}>
            <AccordionContent>
              {t("about.value2Content")}
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value={t("about.value3Title")}>
            <AccordionContent>
              {t("about.value3Content")}
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value={t("about.value4Title")}>
            <AccordionContent>
              {t("about.value4Content")}
            </AccordionContent>
          </AccordionItem>
          <AccordionItem value={t("about.value5Title")}>
            <AccordionContent>
              {t("about.value5Content")}
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </section>
  );
};

export default OurValues;
